/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateEntityApiKeyBody,
  DeleteEntityApiKey200,
  EntityApiKey,
  EntityApiKeysList,
  Error,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve all API keys for the current entity. Keys are masked for security.
 * @summary List entity API keys
 */
export type listEntityApiKeysResponse200 = {
  data: EntityApiKeysList
  status: 200
}

export type listEntityApiKeysResponse400 = {
  data: Error
  status: 400
}

export type listEntityApiKeysResponse401 = {
  data: Error
  status: 401
}

export type listEntityApiKeysResponse403 = {
  data: Error
  status: 403
}

export type listEntityApiKeysResponse404 = {
  data: Error
  status: 404
}

export type listEntityApiKeysResponse500 = {
  data: Error
  status: 500
}

export type listEntityApiKeysResponseSuccess = (listEntityApiKeysResponse200) & {
  headers: Headers;
};
export type listEntityApiKeysResponseError = (listEntityApiKeysResponse400 | listEntityApiKeysResponse401 | listEntityApiKeysResponse403 | listEntityApiKeysResponse404 | listEntityApiKeysResponse500) & {
  headers: Headers;
};

export type listEntityApiKeysResponse = (listEntityApiKeysResponseSuccess | listEntityApiKeysResponseError)

export const getListEntityApiKeysUrl = () => {


  

  return `/entities/api-keys`
}

export const listEntityApiKeys = async ( options?: RequestInit): Promise<listEntityApiKeysResponse> => {
  
  return customFetch<listEntityApiKeysResponse>(getListEntityApiKeysUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a new entity-scoped API key (ek_* prefix). This key can only access this specific entity.
 * @summary Create entity API key
 */
export type createEntityApiKeyResponse201 = {
  data: EntityApiKey
  status: 201
}

export type createEntityApiKeyResponse400 = {
  data: Error
  status: 400
}

export type createEntityApiKeyResponse401 = {
  data: Error
  status: 401
}

export type createEntityApiKeyResponse403 = {
  data: Error
  status: 403
}

export type createEntityApiKeyResponse404 = {
  data: Error
  status: 404
}

export type createEntityApiKeyResponse422 = {
  data: ValidationError
  status: 422
}

export type createEntityApiKeyResponse500 = {
  data: Error
  status: 500
}

export type createEntityApiKeyResponseSuccess = (createEntityApiKeyResponse201) & {
  headers: Headers;
};
export type createEntityApiKeyResponseError = (createEntityApiKeyResponse400 | createEntityApiKeyResponse401 | createEntityApiKeyResponse403 | createEntityApiKeyResponse404 | createEntityApiKeyResponse422 | createEntityApiKeyResponse500) & {
  headers: Headers;
};

export type createEntityApiKeyResponse = (createEntityApiKeyResponseSuccess | createEntityApiKeyResponseError)

export const getCreateEntityApiKeyUrl = () => {


  

  return `/entities/api-keys`
}

export const createEntityApiKey = async (createEntityApiKeyBody: CreateEntityApiKeyBody, options?: RequestInit): Promise<createEntityApiKeyResponse> => {
  
  return customFetch<createEntityApiKeyResponse>(getCreateEntityApiKeyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEntityApiKeyBody,)
  }
);}
  

/**
 * Permanently delete an entity API key. This action cannot be undone.
 * @summary Delete entity API key
 */
export type deleteEntityApiKeyResponse200 = {
  data: DeleteEntityApiKey200
  status: 200
}

export type deleteEntityApiKeyResponse400 = {
  data: Error
  status: 400
}

export type deleteEntityApiKeyResponse401 = {
  data: Error
  status: 401
}

export type deleteEntityApiKeyResponse403 = {
  data: Error
  status: 403
}

export type deleteEntityApiKeyResponse404 = {
  data: Error
  status: 404
}

export type deleteEntityApiKeyResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteEntityApiKeyResponse500 = {
  data: Error
  status: 500
}

export type deleteEntityApiKeyResponseSuccess = (deleteEntityApiKeyResponse200) & {
  headers: Headers;
};
export type deleteEntityApiKeyResponseError = (deleteEntityApiKeyResponse400 | deleteEntityApiKeyResponse401 | deleteEntityApiKeyResponse403 | deleteEntityApiKeyResponse404 | deleteEntityApiKeyResponse422 | deleteEntityApiKeyResponse500) & {
  headers: Headers;
};

export type deleteEntityApiKeyResponse = (deleteEntityApiKeyResponseSuccess | deleteEntityApiKeyResponseError)

export const getDeleteEntityApiKeyUrl = (id: string,) => {


  

  return `/entities/api-keys/${id}`
}

export const deleteEntityApiKey = async (id: string, options?: RequestInit): Promise<deleteEntityApiKeyResponse> => {
  
  return customFetch<deleteEntityApiKeyResponse>(getDeleteEntityApiKeyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

